import { render, staticRenderFns } from "./OpConfirm.vue?vue&type=template&id=c994f964&scoped=true&"
import script from "./OpConfirm.vue?vue&type=script&lang=js&"
export * from "./OpConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OpConfirm.vue?vue&type=style&index=0&id=c994f964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c994f964",
  null
  
)

export default component.exports